/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `lt_2` - Mai puțin sau egal cu 2 ani
 * * `gte_2` - Greater than 2 years
 */
export enum DriverExperienceEnum {
  LT_2 = 'lt_2',
  GTE_2 = 'gte_2',
}
